import { CompanyLayout } from "@/components/layout";
import { requireCompany } from "@/utils/routeGuards";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/app/companies/$company_id")({
  beforeLoad: async ({ params }: { params: { company_id: string } }): Promise<void> => {
    // Skip onboarding check here - it will be handled by child routes
    // The onboarding route itself needs to allow access
    await requireCompany(params.company_id, { skipOnboardingCheck: true });
  },
  component: CompanyLayout,
});
